import { useQuery } from '@tanstack/react-query';
import { BaseHTTPError } from '../errors';
import { useConfigContext } from '../context';
import { TUser } from '../api/schemas/user';
import { getUser } from '../api/queries/user';

const QUERY_KEY = 'user';

export const useUser = ({ enabled }: { enabled: boolean }) => {
  const { config } = useConfigContext();
  if (!config.apiUrls?.aleweb) {
    throw new Error('Missing API URL');
  }

  return useQuery<TUser, BaseHTTPError>({
    queryKey: [QUERY_KEY],
    queryFn: () => getUser({ baseUrl: config.apiUrls?.aleweb as string }),
    retry: false,
    enabled,
  });
};
